import { createFileRoute } from '@tanstack/react-router';
import { UnifiedInvoiceList } from '@/components/features/invoices/unified-invoice-list';
import { useQuery } from 'convex/react';
import { api } from '@/lib/api';
import { LoadingSpinner } from '@/components/ui/loading-spinner';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_protected/invoices')({
  component: InvoicesPage,
});

function InvoicesPage() {
  const { t } = useTranslation('invoices');
  const user = useQuery(api.template.users.getCurrentUser);

  if (user === undefined) {
    return <LoadingSpinner />;
  }

  if (!user || 'needsCreation' in user || (user.role !== 'provider' && user.role !== 'substitute')) {
    return <div className='p-8 text-center'>{t('page.accessDenied')}</div>;
  }

  return (
    <div className='container mx-auto px-4 md:px-8 py-8 space-y-8'>
      <div className='flex flex-col gap-1.5'>
        <h1 className='text-2xl font-bold tracking-tight'>{t('page.title')}</h1>
        <p className='text-sm text-muted-foreground'>{t('page.description')}</p>
      </div>

      <UnifiedInvoiceList />
    </div>
  );
}
